import {
  MYPAGE_RECEIPT_REQUEST,
  MYPAGE_RECEIPT_REQUEST_SUCCESS,
  MYPAGE_RECEIPT_REQUEST_FAIL
} from 'constants/action-types';

const initialState = {
  data: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MYPAGE_RECEIPT_REQUEST:
      return initialState;

    case MYPAGE_RECEIPT_REQUEST_SUCCESS:
      return {
        url: action.payload.data
      };

    case MYPAGE_RECEIPT_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/mypage/receipt.js